import * as React from "react";
import { useRef, useState, useLayoutEffect } from "react";
import styled from "styled-components";
import Tooltip from "components/common/Tooltip";
import useElementDimensions from "hooks/useElementDimensions";
const Wrapper = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: normal;
`;
const TextOverflowEllipsis = ({ children, titleOverride = void 0, className = void 0 }) => {
  const ref = useRef(null);
  const { width } = useElementDimensions(ref);
  const [isTruncated, setIsTruncated] = useState(false);
  useLayoutEffect(() => {
    setIsTruncated(!!ref.current && ref.current.scrollWidth > ref.current.clientWidth);
  }, [children, width]);
  return /* @__PURE__ */ React.createElement(
    Tooltip,
    {
      label: titleOverride || children,
      disabled: titleOverride === void 0 && !isTruncated,
      multiline: true,
      maw: 400
    },
    /* @__PURE__ */ React.createElement(Wrapper, { ref, className }, children)
  );
};
export default TextOverflowEllipsis;
